var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CardDocument',{attrs:{"document":_vm.projectDocument,"title":_vm.projectDocument.title}},[(_vm.canDelete)?_c('Btn',{staticClass:"ib sm inv no-border danger",attrs:{"slot":"actions","icon":"danger","isLoading":_vm.isDeleting},on:{"click":function($event){return _vm.PROMPT({
      confirm: _vm.remove,
      text: 'Ar tikrai norite ištrinti šį projekto dokumentą?',
    })}},slot:"actions"},[_vm._v(" Ištrinti ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }